module.exports = __webpack_public_path__ + "07_bob_gold.a49db48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/07_bob_gold.png
// module id = 6Tc9
// module chunks = 0